import {
  environmentSchema,
  getEnvironmentsSchema,
  envSyncLogSchema,
  triggerCloneSchema,
  getSyncLogSchema,
  getSyncLogsSchema,
} from './environments.schemas';
import { Environment } from './environments.types';

const environmentsSchema = {
  getEnvironmentsSchema,
  environmentSchema,
  envSyncLogSchema,
  triggerCloneSchema,
  getSyncLogSchema,
  getSyncLogsSchema,
};

export { environmentsSchema };
export type { Environment };
